<template>
  <FlotoAnchorLink :aria-label="$t('close')" @click="triggerAction">
    <MIcon name="times-circle" class="action-menu-icon" />
    <span class="ml-1 action-menu-text"> {{ $t('close') }} </span>
    <FlotoConfirmModal
      :open="showModal"
      prevent-auto-close-on-confirm
      :processing="processing"
      @hide="showModal = false"
      @confirm="handleConfirmAction"
    >
      <template v-slot:icon>
        <MIcon
          name="times-circle"
          class="w-full text-secondary-green"
          size="2x"
        />
      </template>
      <template v-slot:message>
        {{
          $t('confirm_close', {
            resource: $tc(moduleName),
          })
        }}
      </template>
    </FlotoConfirmModal>
  </FlotoAnchorLink>
</template>

<script>
export default {
  name: 'Close',
  props: {
    moduleName: { type: String, required: true },
    handleCloseRequests: { type: Function, default: undefined },
  },
  data() {
    return {
      showModal: false,
      processing: false,
    }
  },
  methods: {
    handleConfirmAction() {
      this.$emit('done')
      if (this.handleCloseRequests) {
        this.processing = true
        this.handleCloseRequests()
          .then(() => {
            this.showModal = false
          })
          .finally(() => (this.processing = false))
      } else {
        this.showModal = false
      }
    },
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showModal = true
      }, 400)
    },
  },
}
</script>
